import ChipButton from '@/components/Layout/Chip';
import ImageComponent from '../Image';
import classNames from '@/utils/className';

export default function FeaturedProductExclusive({ onHome = false }) {
  const textsLinks = {
    onHome: {
      title: 'Sobre OPPO',
      subtitle: null,
      describe: 'Junte-se à OPPO e transforme cada momento em algo extraordinário.',
      link: '/oppo',
    },
    onLp: {
      title: 'Ofertas OPPO',
      subtitle: 'As Melhores ofertas',
      describe: 'Aproveite as ofertas exclusivas em produtos OPPO e eleve sua experiência tecnológica.',
      link: 'https://ofertas.canaltech.com.br/marca/oppo/',
    },
  };

  const backgroundOppo = 'https://t.ctcdn.com.br/QFdnjPQOAnsY-aHSkABkXT-BcN4=/i1068821.jpeg';

  return (
    <div className={classNames('flex w-full gap-5 phone:flex-col')}>
      <a
        href={onHome ? textsLinks.onHome.link : textsLinks.onLp.link}
        title={onHome ? textsLinks.onHome.title : textsLinks.onLp.title}
        target="_blank"
        key="#"
        className="group w-full no-underline"
        rel="noreferrer">
        <div
          className={classNames(
            'relative flex h-[375px] flex-col items-center justify-center overflow-hidden',
            'before:absolute before:bottom-0 before:left-0 before:right-0',
            "before:top-0 before:z-[1] before:bg-black/60 before:content-['']",
            onHome && 'rounded-2xl'
          )}>
          <div className="relative h-full w-full transition-all duration-300 ease-in-out group-hover:scale-105">
            <ImageComponent
              className="img-prod-exclusive opacity-60"
              src={backgroundOppo}
              alt={
                'Smartphone Oppo com tampa traseira transparente mostrando componentes internos e câmeras em destaque, com inscrição Powered by MariSilicon sobre fundo preto.'
              }
            />
          </div>

          <div className="absolute z-[1] flex h-full flex-col items-center justify-center py-10">
            <div className="flex border-mglGray50">
              <ImageComponent className="img-prod-exclusive opacity-60" width={190} height={45} src={'/oppo-logo.png'} alt={'none'} />
            </div>

            {/* miolo texto */}
            <div className="py-6">
              {!onHome && <h3 className="text-center text-2xl font-bold text-mglGray50">{textsLinks.onLp.subtitle}</h3>}
              <p className="max-w-[280px] text-center text-base text-mglGray50 sm:max-w-full">
                {onHome ? textsLinks.onHome.describe : textsLinks.onLp.describe}
              </p>
            </div>

            {/* miolo texto */}

            <ChipButton
              className="rounded-full border-0 px-8 py-4 text-2xl  shadow-[0_3px_0_0_#0086ff]"
              texto={onHome ? textsLinks.onHome.title : textsLinks.onLp.title}
              color="black"
              title={onHome ? textsLinks.onHome.title : textsLinks.onLp.title}
              borderColor="white"
              chipSize="medium"
              backgroundColor="white"
              link={onHome ? textsLinks.onHome.link : textsLinks.onLp.link}
              target="_blank"
              rel="noreferrer"
            />
          </div>
        </div>
      </a>
    </div>
  );
}
